import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from '../src/components/layout/reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App/>);
reportWebVitals();